<template>
  <div class="main">
    <div class="mapInfo">
      <div class="map">
        <h2>Direccion</h2>
        <p>
          Calle Barcelona, 14<br>
          Estepona - Málaga
        </p>
        <div class="googlemaps">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3210.1998532729426!2d-5.149651184720501!3d36.42854988002681!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd0cd6a14cbdb42f%3A0xff3303d3787bdaad!2sCalle%20Barcelona%2C%2014%2C%2029680%20Estepona%2C%20M%C3%A1laga!5e0!3m2!1ses!2ses!4v1599827187880!5m2!1ses!2ses" width="100%" height="300" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
        </div>
      </div>
      <div>
        <div class="contact">
          <h2>Contacto</h2>
          <table>
            <tr>
              <td><i class="fas fa-phone" /></td>
              <td>
                <a :href="`tel:+34${$config.telefono.replace(/ /g, '')}`">
                  {{$config.telefono}}
                </a>
              </td>
            </tr>
            <tr>
              <td><i class="far fa-envelope" /></td>
              <td>
                <a :href="`mailto:${$config.mail}?subject=Información`">
                  {{$config.mail}}
                </a>
              </td>
            </tr>
            <tr>
              <td><i class="fab fa-instagram" /></td>
              <td><a :href=$config.instagram target="_blank">@antoniogomezcaceres</a></td>
            </tr>
            <tr>
              <td><i class="fab fa-facebook" /></td>
              <td><a :href=$config.facebook target="_blank">Productosdelmarag</a></td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="contactform">
      <ContactForm />
    </div>
  </div>
</template>

<script>
import ContactForm from '@/components/ContactForm.vue';

export default {
  name: 'contacto',
  components: {
    ContactForm,
  },
};
</script>

<style lang="scss" scoped>
  .main {
    margin-top: 20px;
    color: black;
    width: 100%;
    .mapInfo {
      display: grid;
      margin: 50px 10px 50px 10px;
      @media only screen and (min-width: 1000px) {
        grid-template-columns: 50% 50%;
      }

      h2 {
        color: $dorado;
        font-size: 18px;
        text-align: center;
        margin-bottom: 20px;
      }

      .map {
        color: black;
        font-size: 14px;
        text-align: center;
        margin-bottom: 50px;
        p {
          line-height: 1.3;
        }
        .googlemaps {
          max-width: 800px;
          display: block;
          margin: 10px auto;
        }
      }

      .contact {
        color: black;
        font-size: 14px;
        a { color: black; }
        i {
          font-size: 30px;
          margin-right: 20px;
        }
        table {
          margin: 0 auto;
          td:first-child {
            text-align: center;
          }
          td {
            text-align: left;
            vertical-align: middle;
            padding: 5px;
          }
          a {
            &:hover {
              color: $dorado;
            }
          }
        }
      }
    }
  }
</style>
